import { IApplicationState } from '../../types/redux';
import { formatPrice } from '../../utils/formatters/price';

export const selectPrice = (state: IApplicationState) => {
  const { startPrice, endPrice } = state.projectData.project;

  return {
    startPrice: startPrice ? `от ${formatPrice(startPrice)}` : undefined,
    endPrice: endPrice ? `до ${formatPrice(endPrice)}` : undefined,
  };
};
